export const getDurablePhase4Items = (phase4Data) =>
  Array.isArray(phase4Data?.favorite_things) ? phase4Data.favorite_things : [];

export const getPhase4RequiredItemCount = (config) => {
  const configuredCount = typeof config === 'object'
    ? config?.phase4_num_items
    : config;
  return Math.max(1, Number(configuredCount) || 10);
};

export const isPhase4DurablyComplete = (phase4Data, config) => {
  const required = getPhase4RequiredItemCount(config);
  // Explicit drafts are ready to submit, not already submitted.
  // Legacy records without a submission flag retain their durable summary.
  return phase4Data?.submitted !== false && getDurablePhase4Items(phase4Data).length >= required;
};

export const getPhase4DurableState = (phase4Data, config) => {
  const itemCount = getDurablePhase4Items(phase4Data).length;
  if (itemCount >= getPhase4RequiredItemCount(config)) return 'complete';
  return itemCount > 0 ? 'partial' : 'empty';
};

// Psychologists never use client-local start/submission state to choose their
// Phase 4 screen. Both durable partial and complete records belong in the
// existing review/categorization workflow; only a genuinely empty record may
// expose the start screen.
export const getPhase4ReviewerRenderState = ({ phase4Data, settings, dataReady, settingsReady }) => {
  if (!dataReady || !settingsReady) return 'loading';
  return getPhase4DurableState(phase4Data, settings) === 'empty' ? 'intro' : 'review';
};
